import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
const PRODUCT_LINKS = [{
  label: 'Class IV Laser',
  href: '#category-class-iv-laser'
}, {
  label: 'Shockwave',
  href: '#category-shockwave'
}, {
  label: 'High Energy Inductive Therapy',
  href: '#category-high-energy-inductive-therapy'
}, {
  label: 'Whole Body Red Light / LED Therapy',
  href: '#category-whole-body-red-light-led-therapy'
}, {
  label: 'Thermal Imaging',
  href: '#category-thermal-imaging'
}, {
  label: 'Peptides/Stem Cells',
  href: '#category-peptides-stem-cells'
}, {
  label: 'RegenOMedix',
  href: '#category-peptides-stem-cells',
  nested: true
}, {
  label: 'Used Equipment',
  href: '#category-used-equipment'
}, {
  label: 'Concierge Modality Suite',
  href: '#category-concierge-modality-suite'
}, {
  label: 'Neuro Reformer',
  href: '#category-neuro-reformer'
}];
const NAV = [{
  label: 'Concierge Suite',
  href: '#concierge'
}, {
  label: 'Used Equipment',
  href: '#used-equipment'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const location = useLocation();
  function closeAllMenus() {
    setMobileMenuOpen(false);
    setDesktopProductsOpen(false);
    setMobileProductsOpen(false);
  }
  function handleSamePageAnchorClick(event: React.MouseEvent<HTMLAnchorElement>, hash: string) {
    event.preventDefault();
    const target = document.querySelector(hash);
    if (!target) return;
    closeAllMenus();
    window.history.pushState(null, '', hash);
    window.setTimeout(() => {
      const header = document.querySelector('header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const top = Math.max(0, targetTop - headerHeight - 20);
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }, 50);
  }
  return <header className="sticky top-0 z-50 w-full border-b border-white/15 bg-navy text-white shadow-[0_8px_24px_-16px_rgba(9,10,42,0.8)]" data-id="element-58" data-mp="18mtv5hqwnvm6">
      <div className="mx-auto flex h-[82px] max-w-7xl items-center justify-between px-5 sm:px-8 xl:px-3" data-id="element-59" data-mp="1cq026rludqtp">
        <Link to="/" aria-label="JAG Medical Solutions home" onClick={closeAllMenus} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-60" data-mp="yr0crhqi97wh">
          <Logo data-id="element-61" data-mp="2xzxe5wox40nx" />
        </Link>

        <nav className="hidden items-center gap-3 xl:flex" aria-label="Primary" data-id="element-62" data-mp="meeow771aise">
          <Link to="/" className={`relative py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === '/' && !location.hash ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-63" data-mp="mcboct89979f">
            Home
            {location.pathname === '/' && !location.hash && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-64" data-mp="1059pkw7dptkw" />}
          </Link>

          <div className="group relative" onMouseEnter={() => setDesktopProductsOpen(true)} onMouseLeave={() => setDesktopProductsOpen(false)} onKeyDown={event => {
          if (event.key === 'Escape') setDesktopProductsOpen(false);
        }} data-id="element-65" data-mp="1f2tslxkpteof">
            <button type="button" aria-controls="desktop-products-menu" aria-expanded={desktopProductsOpen} aria-haspopup="menu" onClick={() => setDesktopProductsOpen(value => !value)} className={`inline-flex items-center gap-1.5 py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${desktopProductsOpen ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-66" data-mp="3bxot5nv9lq8o">
              Products
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${desktopProductsOpen ? 'rotate-180' : ''}`} data-id="element-67" data-mp="1t8vryv58i8be" />
            </button>

            <span className="pointer-events-auto absolute left-0 top-full z-[59] h-3 w-[360px] max-w-[calc(100vw-40px)]" aria-hidden="true" data-id="element-68" data-mp="1y0vmg82jc90l" />
            <div id="desktop-products-menu" className={`invisible pointer-events-none absolute left-0 top-full z-[60] mt-3 w-[360px] max-w-[calc(100vw-40px)] origin-top rounded-lg border border-white/15 bg-navy p-2 opacity-0 shadow-2xl shadow-black/35 transition-[opacity,transform,visibility] duration-150 group-hover:visible group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:visible group-focus-within:pointer-events-auto group-focus-within:opacity-100 ${desktopProductsOpen ? 'visible pointer-events-auto opacity-100' : ''}`} role="menu" aria-label="Products" data-id="element-69" data-mp="15hylvz04e582">
              <div className="grid gap-0.5" data-id="element-70" data-mp="5ati57pioqpe">
                {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={`whitespace-nowrap rounded-md py-2 text-[15px] font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10 focus-visible:text-teal-light ${item.nested ? 'ml-3 border-l border-teal/40 pl-3 pr-3 text-[14px] text-teal-light/90' : 'px-3'}`} role="menuitem" data-id="element-71" data-mp="19rl8xj2oqql">
                    {item.label}
                  </a>)}
              </div>
              <div className="my-2 border-t border-white/15" data-id="element-72" data-mp="dxmfkp61ocp" />
              <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2 text-[15px] font-semibold text-teal-light transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" role="menuitem" data-id="element-73" data-mp="gjurmjvs7vz">
                Product of the Month
              </a>
            </div>
          </div>

          {NAV.map(item => {
          const className = `relative py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === item.to ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`;
          const activeIndicator = item.to && location.pathname === item.to && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-74" data-mp="1pvuuijzuqj31" />;
          return item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={className} data-id="element-75" data-mp="1kykwifyecz3l">
                {item.label}
              </a> : <Link key={item.to} to={item.to ?? '/'} className={className} data-id="element-76" data-mp="3a9d0xlpruh9l">
                {item.label}
                {activeIndicator}
              </Link>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-77" data-mp="13oqrn85ikbzu">
          <a href={CONTACT.phoneHref} className="hidden items-center gap-2 rounded-full bg-teal px-5 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:inline-flex" data-id="element-78" data-mp="18lh7budep5kq">
            <PhoneIcon className="h-4 w-4" data-id="element-79" data-mp="1mfrmbjzlpldl" />
            Book a Call
          </a>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy xl:hidden" onClick={() => setMobileMenuOpen(value => !value)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} data-id="element-80" data-mp="1ranj0xfs8wx1">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-81" data-mp="2ffodeas59noj" /> : <MenuIcon className="h-6 w-6" data-id="element-82" data-mp="2fe3ksqpe4etb" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && <div className="border-t border-white/15 bg-navy xl:hidden" data-id="element-83" data-mp="26frt0lcsfaza">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-3 sm:px-8" aria-label="Mobile" data-id="element-84" data-mp="26dowdih4qjll">
            <Link to="/" onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-85" data-mp="2z3nsfxtqrgzr">
              Home
            </Link>

            <div className="border-b border-white/10" data-id="element-86" data-mp="1inkubfjlarwp">
              <button type="button" onClick={() => setMobileProductsOpen(value => !value)} aria-expanded={mobileProductsOpen} className="flex w-full items-center justify-between py-3 text-left text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-87" data-mp="1dq2tydjn1l0b">
                Products
                <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileProductsOpen ? 'rotate-180' : ''}`} data-id="element-88" data-mp="1vsm5et3ukyjc" />
              </button>
              {mobileProductsOpen && <div className="mb-3 rounded-lg border border-white/10 bg-white/[0.05] p-2" data-id="element-89" data-mp="25qa39rwr2m5q">
                  {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={`block rounded-md py-2.5 text-sm font-medium text-white/80 hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10 ${item.nested ? 'ml-3 border-l border-teal/40 pl-3 pr-3 text-teal-light/90' : 'px-3'}`} data-id="element-90" data-mp="20qnm57dswlrn">
                      {item.label}
                    </a>)}
                  <div className="my-1.5 border-t border-white/15" data-id="element-91" data-mp="1zbcmysagnr67" />
                  <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2.5 text-sm font-semibold text-teal-light hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" data-id="element-92" data-mp="1za1isrd3shek">
                    Product of the Month
                  </a>
                </div>}
            </div>

            {NAV.map(item => item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-93" data-mp="3naoswzdh06w7">
                  {item.label}
                </a> : <Link key={item.to} to={item.to ?? '/'} onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-94" data-mp="4ebd2af27is">
                  {item.label}
                </Link>)}
            <a href={CONTACT.phoneHref} onClick={closeAllMenus} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-teal px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-95" data-mp="w4fojwzlex9i">
              <PhoneIcon className="h-4 w-4" data-id="element-96" data-mp="1f2a64zeseh3i" />
              Call {CONTACT.phone}
            </a>
          </nav>
        </div>}
    </header>;
}